import {Component, Input, OnInit} from '@angular/core';
import {IAppTypeMap, Ic} from "../../models/common";
import {Utils} from "../../common/utils";
import {SpecToDesign} from "../../models/SpecToDesign";
import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {copyToClipboard, getSoluctionEfficiency, shareText} from "../../commonUtil";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {ISpec} from "../../models/ISpec";
import {select} from "@angular-redux/store";
import {getContextAndParamUrl} from "../../models/utils_specs";
import {HttpClient} from "@angular/common/http";
import {mergeMap} from "rxjs/operators";

@Component({
  selector: 'edsng-select-button',
  templateUrl: './select-button.component.html',
  styleUrls: ['./select-button.component.css']
})
export class SelectButtonComponent implements OnInit {
  @select(["appProjectTypes", "appTypeMap"]) appTypeMap$;
  @select(["appSpec", "spec", "value"]) valueSpec$;
  @select(["appCatalog", "appClass"]) appName$;
  @select(['appToolBar', 'search']) searchField$;

  @Input() designSolution: Ic;
  @Input() inGrid: boolean = false;
  @Input() errorSpecification: boolean = true;
  @Input() showSelect: boolean;
  @Input() customUrl: string = null;

  itemSpec: ISpec<number>;
  typeMap: IAppTypeMap;
  appName: string;
  searchField = "";

  constructor(public snack: MatSnackBar, private act: ActionsService, private http: HttpClient) {
  }

  ngOnInit() {
    this.valueSpec$.subscribe(x => (this.itemSpec = x));
    this.appTypeMap$.subscribe(y => (this.typeMap = y));
    this.appName$.subscribe(w => (this.appName = w));
    this.searchField$.subscribe(z => (this.searchField = z));
  }

  copyStartDesign(event) {
    if (this.customUrl) {
      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
        'start_design_copy',
        'redirect',
        {
          details: this.customUrl,
          topology: this.designSolution.topology,
          cpn: this.designSolution.CPN,
          rpn: this.designSolution.RPN,
          tag: this.inGrid ? "grid" : "selected"
        }
      ));
      copyToClipboard(window.origin + this.customUrl, this.snack);
    } else if (!this.errorSpecification) {
      const d = SpecToDesign.specToLog(this.itemSpec, this.appName);
      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
        'start_design_copy',
        'redirect',
        {
          details: d,
          topology: this.designSolution.topology,
          cpn: this.designSolution.CPN,
          rpn: this.designSolution.RPN,
          tag: this.inGrid ? "grid" : "selected"}));

      // event.stopPropagation();

      SpecToDesign.startDesignURL(
        this.designSolution,
        this.itemSpec,
        this.typeMap,
        this.appName
      ).subscribe(
        ({url}) => {
          const urlFull = url.startsWith("http") ? url : document.location.origin + url;
          copyToClipboard(urlFull, this.snack);
        },
        err => {
          this.act.sendAction(AnalyticsActions.sendAnalyticsException(
            'copy start design error in ' + this.inGrid ? "grid" : "selected" + ': ' + err +
            ' IC=' + this.designSolution.key + ' AppName=' + this.appName + ' Specs=' + JSON.stringify(d)));

          this.snack.open(err + " " + this.designSolution.partNumber, "OK", {
            duration: 3000
          });
        }
      );
    }
  }

  shareStartDesign(event) {
    if (this.customUrl) {
      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
        'start_design_share',
        'redirect',
        {
          details: this.customUrl,
          topology: this.designSolution.topology,
          cpn: this.designSolution.CPN,
          rpn: this.designSolution.RPN,
          tag: this.inGrid ? "grid" : "selected"
        }
      ));
      shareText(window.origin + this.customUrl, this.snack);
    }
    if (!this.errorSpecification) {
      const d = SpecToDesign.specToLog(this.itemSpec, this.appName);
      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
        'start_design_share',
        'redirect',
        {
          details: d,
          topology: this.designSolution.topology,
          cpn: this.designSolution.CPN,
          rpn: this.designSolution.RPN,
          tag: this.inGrid ? "grid" : "selected"}));

      // event.stopPropagation();

      SpecToDesign.startDesignURL(
        this.designSolution,
        this.itemSpec,
        this.typeMap,
        this.appName
      ).subscribe(
        ({url}) => {
          const urlFull = url.startsWith("http") ? url : document.location.origin + url;
          shareText(urlFull, this.snack);
        },
        err => {
          this.act.sendAction(AnalyticsActions.sendAnalyticsException(
            'share start design error in ' + this.inGrid ? "grid" : "selected" + ': ' + err +
            ' IC=' + this.designSolution.key + ' AppName=' + this.appName + ' Specs=' + JSON.stringify(d)));

          this.snack.open(err + " " + this.designSolution.partNumber, "OK", {
            duration: 3000
          });
        }
      );
    }

  }
  selectDesign(event) {
    if (!this.errorSpecification) {
      const d = SpecToDesign.specToLog(this.itemSpec, this.appName);

      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
        'select_design',
        'redirect',
        {
          details: d,
          topology: this.designSolution.topology,
          cpn: this.designSolution.CPN,
          rpn: this.designSolution.RPN,
          tag: this.inGrid ? "grid" : "selected"}));

      getSoluctionEfficiency(this.http, this.appName, this.designSolution, this.itemSpec).pipe(
        mergeMap((ic) =>
          SpecToDesign.startDesignURL(
              ic,
              this.itemSpec,
              this.typeMap,
              this.appName
            )
        )).subscribe(
        ({ic, url, base}) => {
          // window.open(url);
          const detail = {
            versionMessage: "1",
            edsConsoleUrl: "#/widget/param?" + getContextAndParamUrl(this.appName, this.itemSpec, this.searchField, this.inGrid ? "" : ic.key ),
            specs : {
              ic: ic.key,
              efficiency: ic.efficiency,
              input: {
                v: {
                  min: this.itemSpec.input.min,
                  max: this.itemSpec.input.max
                },
                f: this.itemSpec.input.freq ? this.itemSpec.input.freq : 50,
              },
              output: this.itemSpec.output.outputs.map(x => {
                return {
                  v: Math.abs(x.voltage),
                  r: (ic.key && ic.key.search(/:pfc/i) >= 0 ) ? undefined :  2,     // if pfc in key ripple undefined to take the default value else 2%
                  i: x.current
                };
              })
            },
            edsDesignBaseUrl: base,
            edsDesignUrl: url
          };
          // const ev = new CustomEvent('consoleSelection', {detail});
          // window.parent.document.dispatchEvent(ev);
          // used postMessage to avoid cross origin error
          window.parent.postMessage({typeEvent: 'consoleSelection',  detail}, "*" );
        },
        err => {
          this.act.sendAction(AnalyticsActions.sendAnalyticsException(
            'select design error: ' + err +
            ' IC=' +  this.designSolution.key + ' AppName=' + this.appName + ' Specs=' + JSON.stringify(d)));
          this.snack.open(err + " " + this.designSolution.partNumber, "OK", {
            duration: 3000
          });
        }
      );
    }
  }

  startDesign(event) {
    if (this.customUrl) {
      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
        'start_design',
        'redirect',
        {
          details: this.customUrl,
          topology: this.designSolution.topology,
          cpn: this.designSolution.CPN,
          rpn: this.designSolution.RPN,
          tag: this.inGrid ? "grid" : "selected"
        }
      ));
      window.open(this.customUrl, "_blank");
    } else if (!this.errorSpecification) {
      const d = SpecToDesign.specToLog(this.itemSpec, this.appName);

      this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
        'start_design',
        'redirect',
        {
          details: d,
          topology: this.designSolution.topology,
          cpn: this.designSolution.CPN,
          rpn: this.designSolution.RPN,
          tag: this.inGrid ? "grid" : "selected"
        }));

      // event.stopPropagation();
      SpecToDesign.startDesignURL(
        this.designSolution,
        this.itemSpec,
        this.typeMap,
        this.appName
      ).subscribe(
        ({url}) => {
          window.open(url);
        },
        err => {
          this.act.sendAction(AnalyticsActions.sendAnalyticsException(
            'start design error: ' + err +
            ' IC=' +  this.designSolution.key + ' AppName=' + this.appName + ' Specs=' + JSON.stringify(d)));
          this.snack.open(err + " " + this.designSolution.partNumber, "OK", {
            duration: 3000
          });
        }
      );
    }
  }

  private minNumOutput() {
    return Utils.getFieldValue(this.designSolution, 'designData.minNumOutput', 1);
  }

  private isMinNunOutputNotValid() {
    return !(this.itemSpec && this.itemSpec.output.outputs.length >= this.minNumOutput());
  }

  isStartDisabled() {
    return this.errorSpecification === true || this.isMinNunOutputNotValid();
  }

  isSelectionDisabled() {
    return this.isStartDisabled() || !this.hasHtmlApp();
  }

  shareAvailable() {
    // @ts-ignore
    return navigator.share !== undefined;
  }

  hasHtmlApp(): boolean {
    return Utils.getFieldValue(this.designSolution, "app_name", "").endsWith('_html');
  }

  appTypeIcon(): string {
    return this.hasHtmlApp() ? "assets/icons/HTML5_Logo.svg" : "assets/icons/flash_player.svg";
  }
}
